<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-loading="nalaganjeVsebine">
        <div>
          <p class="open-sans-30pt">
            Povezani računi
          </p>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Za enostavnejši vpis v Moj T-2 in ostale T-2 aplikacije, povežite
            svoj uporabniški račun z vašim Facebook, Google ali Apple računom.
            <span v-if="this.prikazTabele === '1'">
              <br/>
            </span>
            Elektronskega naslova tako ne bo več potrebno vpisovati.
          </p>
        </div>
        <div class="postavitev-druzbenih-omrezij">
          <div class="container">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/logo_googleg_48dp.png" alt="Google">
              </div>
              <div class="gumb-wrapper">
                <div v-if="googleId === null">
                  <el-button class="gumb-potrdi" @click="FollowLink(googlePovezava)">
                    POVEŽI Z GOOGLE ID
                  </el-button>
                </div>
                <div v-else>
                  <el-button class="gumb-potrjeno" @click="PrekinitevGoogle">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png"
                         alt="trash" class="ikona-kos">
                    PREKINI POVEZAVO
                  </el-button>
                </div>
              </div>
            </div>
            <div class="odmik-povezav" style="display: flex; flex-direction: column; align-items: center;">
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/iconmonstr-facebook-6.png" alt="Facebook">
              </div>
              <div class="gumb-wrapper">
                <div v-if="fbId === null">
                  <el-button class="gumb-potrdi" @click="FollowLink(facebookPovezava)">
                    POVEŽI S FACEBOOK ID
                  </el-button>
                </div>
                <div v-else>
                  <el-button class="gumb-potrjeno" @click="PrekinitevFB">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png"
                         alt="trash" class="ikona-kos">
                    PREKINI POVEZAVO
                  </el-button>
                </div>
              </div>
            </div>
            <div class="odmik-povezav odmik-apple-id" style="display: flex; flex-direction: column; align-items: center;">
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/png-apple-logo-9708.png"
                     alt="Apple" style="height: 60px; width: 60px;">
              </div>
              <div class="gumb-wrapper">
                <div v-if="appleId === null">
                  <el-button class="gumb-potrdi" @click="FollowLink(appleIdPovezava)">
                    POVEŽI Z APPLE ID
                  </el-button>
                </div>
                <div v-else>
                  <el-button class="gumb-potrjeno" @click="PrekinitevAppleId">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-trash-alt.png"
                         alt="trash" class="ikona-kos">
                    PREKINI POVEZAVO
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="postavitev-info">
            <div class="info-okvir">
              <div class="postavitev-info-icone">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="postavitev-info-tekst">
                <p class="modra-barva-info navadno-besedilo">
                  S povezavo zunanjega računa (Google, Facebook, Apple) boste lahko še enostavneje
                  dostopali do T-2 aplikacij. Dovolj bo le klik na gumb »prijava«, brez ponovnega
                  vpisa uporabniških podatkov.
                  <span class="postavitev-vsebine-info-box">
                    <b>Opozorilo:</b>
                    Povezavo z zunanjimi računi priporočamo
                    <br/>
                    <b>le na osebnih napravah</b>.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div style="clear: both"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {configSSO} from '../../../../assets/js/config.js'
import {Button, Select, Alert, MessageBox} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'

export default {
  name: 'Druzabno',
  mixins: [PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      facebookPovezava: '',
      googlePovezava: '',
      nalaganjeVsebine: false,
      fbId: null,
      googleId: null,
      appleId: null,
      passwordLastSetDate: null,
      hasMultipleLoginMethods: false,
      mejnaSirinaTabela: 1000,
      prikazTabele: '0',
      appleIdPovezava: ''
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.dispatchEvent(new Event('resize'))
    })
    this.GetUserData()
    this.InitPovezave()
    if (this.$route.query.napaka !== undefined) {
      this.ShowErrorMessage({ 'message': this.$route.query.napaka })
    }
  },
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Alert.name]: Alert,
    [MessageBox.name]: MessageBox
  },
  methods: {
    InitPovezave () {
      let redirectUrl = new URL(configSSO.AUTH0_CALLBACK_URL)
      let baseUrl = 'https://' + configSSO.AUTH0_DOMAIN + '/?'
      baseUrl += 'redirect_uri=' + redirectUrl.origin + '/Mojprofil/Druzabno'
      this.googlePovezava = baseUrl + '&googleLogin=1'
      this.facebookPovezava = baseUrl + '&fbLogin=1'
      this.appleIdPovezava = baseUrl + '&appleLogin=1'
    },
    FollowLink (povezava) {
      this.clientAgent.t2Auth.deleteTokens()
      window.location = povezava
    },
    GetUserData () {
      this.nalaganjeVsebine = true
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info?',
        param,
        null,
        'SetUserData',
        'ErrSporocilo')
    },
    SetUserData (podatki) {
      this.googleId = podatki.googleId
      this.fbId = podatki.fbId
      this.appleId = podatki.appleId
      this.passwordLastSetDate = podatki.passwordLastSetDate
      this.hasMultipleLoginMethods = podatki.hasMultipleLoginMethods
      this.nalaganjeVsebine = false
    },
    PotrdiPrekinitev () {
      let title = this.hasMultipleLoginMethods ? 'Opozorilo!' : 'Želite prekiniti povezavo?'
      let message = this.hasMultipleLoginMethods
        ? 'Ste prepričani, da želite prekiniti povezavo vašega T-2 ID z izbranim zunanjim omrežjem?'
        : 'Prekinitev povezave bo odstranila vašo trenutno možnost prijave v T‑2 ID. Ob naslednji prijavi v portal ' +
        'MOJ T-2 uporabite možnost <b>»Pozabljeno geslo«</b> in nastavite geslo za prijavo z e-mail naslovom.'
      return MessageBox.confirm(message, {
        dangerouslyUseHTMLString: true,
        title: title,
        confirmButtonText: 'Potrdi',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      })
    },
    PrekinitevFB () {
      this.PotrdiPrekinitev().then(() => {
        this.nalaganjeVsebine = true
        let param = []
        this.clientAgent.postWsRequest(
          this,
          'user/prekiniFbPovezavo?',
          param,
          null,
          'SetPrekinitevFB',
          'ErrSporocilo')
      }).catch(() => {})
    },
    SetPrekinitevFB () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Vašo povezavo s Facebook računom smo prekinili. Račun lahko kadarkoli ponovno' +
        ' povežete.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUserData()
    },
    PrekinitevGoogle () {
      this.PotrdiPrekinitev().then(() => {
        this.nalaganjeVsebine = true
        let param = []
        this.clientAgent.postWsRequest(
          this,
          'user/prekiniGooglePovezavo?',
          param,
          null,
          'SetPrekinitevGoogle',
          'ErrSporocilo')
      }).catch(() => {})
    },
    SetPrekinitevGoogle () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Vašo povezavo s Google računom smo prekinili. Račun' +
        ' lahko kadarkoli ponovno povežete.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUserData()
    },
    ErrSporocilo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.nalaganjeVsebine = false
    },
    PrekinitevAppleId () {
      this.PotrdiPrekinitev().then(() => {
        this.nalaganjeVsebine = true
        let param = []
        this.clientAgent.postWsRequest(
          this,
          'user/prekiniApplePovezavo?',
          param,
          null,
          'SetPrekinitevAppleId',
          'ErrSporocilo')
      }).catch(() => {})
    },
    SetPrekinitevAppleId () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Vašo povezavo z Apple ID računom smo prekinili. Račun' +
        ' lahko kadarkoli ponovno povežete.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUserData()
    }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/druzabno.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Druzabno.vue